module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.mode == 'info') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.model[_vm.prop])
    }
  }) : (_vm.mode == 'form') ? _c('div', [_c('quill-editor', {
    ref: "htmlEditor",
    attrs: {
      "config": _vm.quillConfig
    },
    on: {
      "ready": function($event) {
        return _vm.onEditorReady($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      }
    },
    model: {
      value: (_vm.model[_vm.prop]),
      callback: function($$v) {
        _vm.$set(_vm.model, _vm.prop, $$v)
      },
      expression: "model[prop]"
    }
  }), _vm._v(" "), (_vm.selectedInfobitIdKnown) ? _c('div', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: ([]),
      expression: "[]"
    }],
    staticClass: "drop-link-area",
    attrs: {
      "bag": "infobits"
    },
    domProps: {
      "innerHTML": _vm._s((!_vm.textSelection) ?
        'Drop an infobit to create a link' : 'Drop an infobit to create a link labelled &ldquo;' + _vm.textSelection + '&rdquo;')
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb26eec0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data-fields/html-field.vue
// module id = 152
// module chunks = 0